import axios from 'axios';
import i18n from '../../../i18next';

import {
    LOAD_CUSTOMER_INSIGHT,
    LOAD_CUSTOMER_INSIGHT_DISABLED,
    LOADING,
    LOAD_CUSTOMER_INSIGHT_ORDER_TYPE_SEARCH,
    LOAD_CUSTOMER_INSIGHT_PAYMENT_TYPE_SEARCH,
    LOAD_CUSTOMER_INSIGHT_SOURCE_TYPE_SEARCH,
    LOAD_CUSTOMER_INSIGHT_ORDER_FREQUENCY_SEARCH,
    LOAD_CUSTOMER_INSIGHT_DAILY_ORDER_FREQUENCY_SEARCH,
    LOAD_CUSTOMER_INSIGHT_PRODUCT_SUMMART_SEARCH,
    LOAD_CUSTOMER_INSIGHT_PROMOTION_SUMMARY_SEARCH,
    LOAD_CUSTOMER_INSIGHT_PROMOTION_SEARCH,
    LOAD_CUSTOMER_INSIGHT_PROMOTION_NAMES,
    LOAD_CUSTOMER_INSIGHT_REFUND_SEARCH,
    LOAD_CUSTOMER_INSIGHT_ORDER_SEARCH,
    LOAD_CUSTOMER_INSIGHT_NOTIFICATION_SEARCH
} from "../../types";
import { SERVER_URL, DEFAULT_PAGE_SIZE } from "../../../utils/Constants";
import MessageUtils from "../../../utils/MessageUtils";

export const loadCustomerInsight = (restaurantId, customerId) => {
    return (dispatch, getState) => {

        const url = `${SERVER_URL}/advanced-reporting/customer-summary?customerId=${customerId}&restaurantId=${restaurantId}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadCustomerInsightSuccess(dispatch, response))
            .catch(() => loadCustomerInsightFail(dispatch))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadCustomerInsightSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT, payload: response.data })
};

const loadCustomerInsightFail = dispatch => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_DISABLED })
}

export const loadCustomerInsightOrderSearchSummary = (restaurantId, customerId, fromDate, toDate) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }

        const url = `${SERVER_URL}/advanced-reporting/order-type-search?customerId=${customerId}&restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadCustomerInsightOrderSearchSummarySuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightOrderSearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadCustomerInsightOrderSearchSummarySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_ORDER_TYPE_SEARCH, payload: response.data })
};

export const loadCustomerInsightPaymentSearchSummary = (restaurantId, customerId, fromDate, toDate) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }

        const url = `${SERVER_URL}/advanced-reporting/payment-type-search?customerId=${customerId}&restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadCustomerInsightPaymentSearchSummarySuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightPaymentSearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadCustomerInsightPaymentSearchSummarySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_PAYMENT_TYPE_SEARCH, payload: response.data })
};

export const loadCustomerInsightSourceSearchSummary = (restaurantId, customerId, fromDate, toDate) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }

        const url = `${SERVER_URL}/advanced-reporting/source-type-search?customerId=${customerId}&restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadCustomerInsightSourceSearchSummarySuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightSourceSearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadCustomerInsightSourceSearchSummarySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_SOURCE_TYPE_SEARCH, payload: response.data })
};

export const loadCustomerInsightOrderFrequencySearch = (restaurantId, customerId, fromDate, toDate) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }

        const url = `${SERVER_URL}/advanced-reporting/hourly-statistic-search?customerId=${customerId}&restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadCustomerInsightOrderFrequencySearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightOrderFrequencySearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadCustomerInsightOrderFrequencySearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_ORDER_FREQUENCY_SEARCH, payload: response.data })
};

export const loadCustomerInsightDailyOrderFrequencySearch = (restaurantId, customerId, fromDate, toDate) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }

        const url = `${SERVER_URL}/advanced-reporting/daily-statistic-search?customerId=${customerId}&restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadCustomerInsightDailyOrderFrequencySearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightOrderFrequencySearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadCustomerInsightDailyOrderFrequencySearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_DAILY_ORDER_FREQUENCY_SEARCH, payload: response.data })
};

export const loadCustomerInsightProductSummarySearch = (restaurantId, customerId, fromDate,
    toDate, page, orderTypeId, paymentTypeId, productName) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';
        let orderTypeIdParam = '';
        let paymentTypeIdParam = '';
        let productNameParam = '';
        let restaurantIdParam = `&restaurantId=${restaurantId}`;
        let customerIdParam = `customerId=${customerId}`;
        let pageParam = `&page=${page}`;
        let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }
        if (orderTypeId && orderTypeId !== '') {
            orderTypeIdParam = `&orderTypeId=${orderTypeId}`
        }
        if (paymentTypeId && paymentTypeId !== '') {
            paymentTypeIdParam = `&paymentTypeId=${paymentTypeId}`
        }
        if (productName && productName !== '') {
            productNameParam = `&name=${productName}`
        }

        const url = `${SERVER_URL}/advanced-reporting/product-search?${customerIdParam}${restaurantIdParam}${pageParam}${sizeParam}${fromDateParam}${toDateParam}${orderTypeIdParam}${paymentTypeIdParam}${productNameParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadCustomerInsightProductSummarySearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightProductSummarySearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadCustomerInsightProductSummarySearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_PRODUCT_SUMMART_SEARCH, payload: response.data })
};

export const loadPromotionSummarySearch = (restaurantId, customerId, page, promotionId, promotionName) => {
    return (dispatch, getState) => {

        let promotionIdParam = '';
        let nameParam = '';
        let restaurantIdParam = `&restaurantId=${restaurantId}`;
        let customerIdParam = `customerId=${customerId}`;
        let pageParam = `&page=${page}`;
        let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;

        //If promotionId is set, promotionName must be null
        if (promotionId && promotionId !== '') {
            promotionIdParam = `&promotionId=${promotionId}`
        } else if (promotionName && promotionName !== '') {
            nameParam = `&name=${promotionName}`
        }

        const url = `${SERVER_URL}/advanced-reporting/promotion-summary-search?${customerIdParam}${restaurantIdParam}${pageParam}${sizeParam}${promotionIdParam}${nameParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadPromotionSummarySearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadPromotionSummarySearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadPromotionSummarySearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_PROMOTION_SUMMARY_SEARCH, payload: response.data })
};

export const loadPromotionSearch = (restaurantId, customerId, page, promotionId, promotionName,
    fromDate, toDate, orderTypeId, paymentTypeId, discountTypeId) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';
        let promotionIdParam = '';
        let nameParam = '';
        let orderTypeIdParam = '';
        let paymentTypeIdParam = '';
        let discountTypeIdParam = '';
        let restaurantIdParam = `&restaurantId=${restaurantId}`;
        let customerIdParam = `customerId=${customerId}`;
        let pageParam = `&page=${page}`;
        let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;

        //If promotionId is set, promotionName must be null
        if (promotionId && promotionId !== '') {
            promotionIdParam = `&promotionId=${promotionId}`
        } else if (promotionName && promotionName !== '') {
            nameParam = `&name=${promotionName}`
        }
        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }
        if (orderTypeId && orderTypeId !== '') {
            orderTypeIdParam = `&orderTypeId=${orderTypeId}`
        }
        if (paymentTypeId && paymentTypeId !== '') {
            paymentTypeIdParam = `&paymentTypeId=${paymentTypeId}`
        }
        if (discountTypeId && discountTypeId !== '') {
            discountTypeIdParam = `&discountTypeId=${discountTypeId}`
        }

        const url = `${SERVER_URL}/advanced-reporting/promotion-search?${customerIdParam}${restaurantIdParam}${pageParam}${sizeParam}${promotionIdParam}${nameParam}${fromDateParam}${toDateParam}${orderTypeIdParam}${paymentTypeIdParam}${discountTypeIdParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadPromotionSearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadPromotionSearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadPromotionSearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_PROMOTION_SEARCH, payload: response.data })
};

export const loadPromotionNames = (restaurantId, callback) => {
    return (dispatch, getState) => {

        const url = `${SERVER_URL}/promotion/${restaurantId}/names`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadPromotionNamesSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadPromotionNames')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadPromotionNamesSuccess = (dispatch, response, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_PROMOTION_NAMES, payload: response.data })
    if (callback) {
        callback()
    }
};

export const loadRefundSearch = (restaurantId, customerId, page, fromDate, toDate, amount, orderId) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';
        let amountParam = '';
        let orderIdParam = '';
        let restaurantIdParam = `&restaurantId=${restaurantId}`;
        let customerIdParam = `customerId=${customerId}`;
        let pageParam = `&page=${page}`;
        let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }
        if (amount && amount !== '') {
            amountParam = `&amount=${amount}`
        }
        if (orderId && orderId !== '') {
            orderIdParam = `&orderId=${orderId}`
        }

        const url = `${SERVER_URL}/advanced-reporting/refund-search?${customerIdParam}${restaurantIdParam}${pageParam}${sizeParam}${amountParam}${orderIdParam}${fromDateParam}${toDateParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadRefundSearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadRefundSearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadRefundSearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_REFUND_SEARCH, payload: response.data })
};

export const loadTriggerNotificationSearch = (restaurantId, customerId, page, fromDate, toDate, triggerName, triggerMethod) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';
        let nameParam = '';
        let triggerMethodParam = '';
        let restaurantIdParam = `&restaurantId=${restaurantId}`;
        let customerIdParam = `customerId=${customerId}`;
        let pageParam = `&page=${page}`;
        let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }
        if (triggerName && triggerName !== '') {
            nameParam = `&triggerName=${triggerName}`
        }
        if (triggerMethod && triggerMethod !== '') {
            triggerMethodParam = `&triggerMethod=${triggerMethod}`
        }

        const url = `${SERVER_URL}/advanced-reporting/notification-search?${customerIdParam}${restaurantIdParam}${pageParam}${sizeParam}${triggerMethodParam}${nameParam}${fromDateParam}${toDateParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadTriggerNotificationSearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadNotificationSearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadTriggerNotificationSearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_NOTIFICATION_SEARCH, payload: response.data })
};

export const loadOrderSearch = (restaurantId, customerId, page, fromDate, toDate, address, amount,
    orderTypeId, paymentTypeId, sourceTypeId, orderStatus, orderId) => {
    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';
        let restaurantIdParam = `&restaurantId=${restaurantId}`;
        let customerIdParam = `customerId=${customerId}`;
        let pageParam = `&page=${page}`;
        let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;
        let addressParam = '';
        let amountParam = '';
        let orderTypeIdParam = '';
        let paymentTypeIdParam = '';
        let sourceTypeIdParam = '';
        let orderStatusParam = '';
        let orderIdParam = '';

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }
        if (address && address !== '') {
            addressParam = `&address=${address}`
        }
        if (amount && amount !== '') {
            amountParam = `&amount=${amount}`
        }
        if (orderTypeId && orderTypeId !== '') {
            orderTypeIdParam = `&orderTypeId=${orderTypeId}`
        }
        if (paymentTypeId && paymentTypeId !== '') {
            paymentTypeIdParam = `&paymentTypeId=${paymentTypeId}`
        }
        if (sourceTypeId && sourceTypeId !== '') {
            sourceTypeIdParam = `&sourceId=${sourceTypeId}`
        }
        if (orderStatus && orderStatus !== '') {
            orderStatusParam = `&orderStatus=${orderStatus}`
        }
        if (orderId && orderId !== '') {
            orderIdParam = `&orderId=${orderId}`
        }

        const url = `${SERVER_URL}/advanced-reporting/order-search?${customerIdParam}${restaurantIdParam}${pageParam}${sizeParam}${amountParam}${orderIdParam}${fromDateParam}${toDateParam}${addressParam}${orderTypeIdParam}${paymentTypeIdParam}${sourceTypeIdParam}${orderStatusParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadOrderSearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadOrderSearchFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadOrderSearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_INSIGHT_ORDER_SEARCH, payload: response.data })
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/customerInsight/CustomerInsightAction.js